delay = do ->
  timer = 0
  (callback, ms) ->
    clearTimeout timer
    timer = setTimeout(callback, ms)
    return

window.page_number = 1
window.archived_page_number = 1
window.searching_courses = false
wave_number = $('.wave-details:visible').length

window.addEventListener 'DOMContentLoaded', ->

  window.originalPlaceholderSrc = $('#course-image img').attr('src') || '/assets/image_placeholder.png'

  $(document).on 'click', '[href="#addcourse_popup"]', (event) ->
    $courseImg = $('#course-image img')
    if window.originalPlaceholderSrc
      $courseImg.attr('src', window.originalPlaceholderSrc)
    $('#asset-id-course-image').val('')
    $('.edit-alt-text-modal').hide()
    
    $('#course-image .cs-trash').css('opacity', '0.5')
    $('#course-image .cs-trash').css('pointer-events', 'none')
    $('#course-image .cs-trash').removeClass('trash-allowed')
    $('#course-image .cs-trash').addClass('trash-not-allowed')
    
    $('#addcourse_popup form')[0].reset() if $('#addcourse_popup form')[0]  
    return

  if $('#courses').length
    
    # Function to check if we need to load more courses
    window.checkAndLoadMoreCourses = ->
      return if window.searching_courses
      
      # Get current counts dynamically (in case they've been updated)
      active_courses_count = Number($('#active_courses_count').val()) || 0
      archived_courses_count = Number($('#archived_courses_count').val()) || 0
      
      # Check if we're near the bottom OR if there's no scrollbar (content doesn't fill the window)
      needsMoreContent = $(window).scrollTop() > ($(document).height() - $(window).height() - 50)
      hasNoScrollbar = $(document).height() <= $(window).height()
      
      if needsMoreContent || hasNoScrollbar
        api_call = false
        selected_page = 1
        selected_type = ''
        current_course_count = 0
        
        if $("#archived-courses-grid").is(":visible")
          current_course_count = $('#archived-courses-grid .blueprint-course-card').length
          # Only load if we haven't already loaded all courses
          if current_course_count < archived_courses_count
            window.archived_page_number++
            api_call = true
            selected_page = window.archived_page_number
            selected_type = $("#archived-courses-grid").data('type')
        else if $("#courses-grid").is(":visible")
          current_course_count = $('#courses-grid .blueprint-course-card').length
          # Only load if we haven't already loaded all courses
          if current_course_count < active_courses_count
            window.page_number++
            api_call = true
            selected_page = window.page_number
            selected_type = $("#courses-grid").data('type')
            
        if api_call && selected_page && selected_type
          window.searching_courses = true
          
          $('.user-management-filter-overlay').show()
          url = "/courses?page=#{selected_page}&selected_type=#{selected_type}"
          
          # Preserve search query when paginating
          search_value = $('.course-search').val()
          if search_value && search_value.trim().length > 0
            url += "&search_course=#{encodeURIComponent(search_value)}"
            # Also pass the active/archived status when searching
            if selected_type == $("#courses-grid").data('type')
              url += "&active=true"
            
          $.getScript(url)
            .fail (jqxhr, settings, exception) ->
              $('.user-management-filter-overlay').hide()
              window.searching_courses = false
              # Decrement page number on failure so retry is possible
              if selected_type == $("#archived-courses-grid").data('type')
                window.archived_page_number--
              else
                window.page_number--
              console.error('Failed to load courses:', exception)
              alert('Failed to load more courses. Please try again.')
            .always ->
              # Ensure flag is cleared even if response script doesn't execute
              window.searching_courses = false
    
    # Check on scroll
    $(window).scroll ->
      delay (->
        window.checkAndLoadMoreCourses()
      ), 500
    
    # Also check immediately when page loads (for large windows)
    setTimeout(window.checkAndLoadMoreCourses, 100)

  $('.tooltipped').tooltip()
  COURSE_FILE_LIMITS = $('#course_file_limits').val() && JSON.parse($('#course_file_limits').val())
  APPLICATION_FILE_LIMITS = $('#application_file_limits').val() && JSON.parse($('#application_file_limits').val())
  fileObject = {}
  course_images = {}
  course_backgrounds = {}
  course_logos = {}
  course_welcome_images = {}
  course_welcome_videos = {}
  course_welcome_video_subtitles = {}
  course_welcome_video_thumbnails = {}
  croppie_course = ''

  $('.course-search').keyup ->
    search_course = $(this)
    delay (->
      $('.user-management-filter-overlay').show()
      $(search_course).parents('form').submit()
      return
    ), 1000

  $('#courses').sortable ->
    cursor: "move"

  $('#courses').on('sortstop', (event, ui) ->
    $(this).parents('form').submit()
  )

  $($('#course_name_language').parent()).click (event) ->
    for result in $('#course_name_language_chosen .chosen-results').children()
      text = $(result).text()
      key = $('#course_name_language').find('option:contains("'+text+'")').val()
      for id in $('input[id^="course_name_multi"]')
        if $(id).attr("id") == 'course_name_multi[' + key + ']'
          match = $(id).val()
          break
      if match.length > 0
        $(result).addClass("language-green")
        $(result).removeClass("language-orange")
      else
        $(result).addClass("language-orange")
        $(result).removeClass("language-green")

  $('#course_name_language').attr("data-prev", $('#course_name_language').val())
  $('#email_language_id').attr("data-prev", $('#course_name_language').val())

  $('#course_name_language').change (event) ->
    prev_language_id = $(event.target).attr("data-prev")
    current_language_id = $(event.target).val()
    $(event.target).attr("data-prev", current_language_id)
    $('#course-name-' + current_language_id).css("display", "block")
    $('#course-name-' + prev_language_id).css("display", "none")
    $('#course-image-' + current_language_id).css("display", "block")
    $('#course-image-' + prev_language_id).css("display", "none")
    $('#course-background-' + current_language_id).css("display", "block")
    $('#course-background-' + prev_language_id).css("display", "none")
    $('#course-logo-' + current_language_id).css("display", "block")
    $('#course-logo-' + prev_language_id).css("display", "none")
    $('#course-welcome-image-' + current_language_id).css("display", "block")
    $('#course-welcome-image-' + prev_language_id).css("display", "none")
    $('#course-welcome-video-' + current_language_id).css("display", "block")
    $('#course-welcome-video-' + prev_language_id).css("display", "none")

  $($('#course_welcome_text_language').parent()).click (event) ->
    for result in $('#course_welcome_text_language_chosen .chosen-results').children()
      text = $(result).text()
      key = $('#course_welcome_text_language').find('option:contains("'+text+'")').val()
      for id in $('textarea[id^="course_welcome_text_multi"]')
        if $(id).attr("id") == 'course_welcome_text_multi[' + key + ']'
          match = $(id).val()
          break
      if match.length > 0
        $(result).addClass("language-green")
        $(result).removeClass("language-orange")
      else
        $(result).addClass("language-orange")
        $(result).removeClass("language-green")

  $('#course_welcome_text_language').attr("data-prev", $('#course_welcome_text_language').val())

  $('#course_welcome_text_language').change (event) ->
    prev_language_id = $(event.target).attr("data-prev")
    current_language_id = $(event.target).val()
    $(event.target).attr("data-prev", current_language_id)
    $('#course-welcome-text-' + current_language_id).css("display", "block")
    $('#course-welcome-text-' + prev_language_id).css("display", "none")

  $('#toggle-invite-custom').click (event) ->
    $('#invite-email-customisation').toggle()
    
  $('#course_invite_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-invite-settings').css("display", "block")
    else
      $('.customised-invite-settings').css("display", "none")

  $('#toggle-welcome-custom').click (event) ->
    $('#welcome-email-customisation').toggle()
    
  $('#course_welcome_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-welcome-settings').css("display", "block")
    else
      $('.customised-welcome-settings').css("display", "none")

  $('#email_language_id').change (event) ->
    prev_language_id = $(event.target).attr("data-prev")
    current_language_id = $(event.target).val()
    $(event.target).attr("data-prev", current_language_id)
    $('.course-email-' + current_language_id).css("display", "block")
    $('.course-email-' + prev_language_id).css("display", "none")

  $('#toggle-reset-password-custom').click (event) ->
    $('#reset-password-email-customisation').toggle()

  $('#course_reset_password_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-reset-password-settings').css("display", "block")
    else
      $('.customised-reset-password-settings').css("display", "none")

  $('#toggle-manager-following-custom').click (event) ->
    $('#manager-following-email-customisation').toggle()

  $('#manager_following_email_type').change (event) ->
    if $(event.target).val() == "manager_following_customise"
      $('.customised-manager-following-settings').css("display", "block")
    else
      $('.customised-manager-following-settings').css("display", "none")

  $('#toggle-welcome-manager-custom').click (event) ->
    $('#welcome-manager-email-customisation').toggle()

  $('#welcome_manager_email_type').change (event) ->
    if $(event.target).val() == "welcome_manager_customise"
      $('.customised-welcome-manager-settings').css("display", "block")
    else
      $('.customised-welcome-manager-settings').css("display", "none")

  $('#toggle-invite-manager-custom').click (event) ->
    $('#invite-manager-email-customisation').toggle()

  $('#invite_manager_email_type').change (event) ->
    if $(event.target).val() == "invite_manager_customise"
      $('.customised-invite-manager-settings').css("display", "block")
    else
      $('.customised-invite-manager-settings').css("display", "none")

  $('#toggle-before-user-first-day-custom').click (event) ->
    $('#before-user-first-day-email-customisation').toggle()

  $('#course_before_user_first_day_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-before-user-first-day-settings').css("display", "block")
    else
      $('.customised-before-user-first-day-settings').css("display", "none")

  $('#toggle-finished-course-custom').click (event) ->
    $('#finished-course-email-customisation').toggle()

  $('#course_finished_course_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-finished-course-settings').css("display", "block")
    else
      $('.customised-finished-course-settings').css("display", "none")

  $('#toggle-inactive-user-custom').click (event) ->
    $('#inactive-user-email-customisation').toggle()

  $('#course_inactive_user_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-inactive-user-settings').css("display", "block")
    else
      $('.customised-inactive-user-settings').css("display", "none")

  $('#toggle-story-available-custom').click (event) ->
    $('#story-available-email-customisation').toggle()

  $('#course_story_available_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-story-available-settings').css("display", "block")
    else
      $('.customised-story-available-settings').css("display", "none")

  $('#toggle-remind-course-custom').click (event) ->
    $('#remind-course-email-customisation').toggle()

  $('#course_remind_course_completion_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-remind-course-settings').css("display", "block")
    else
      $('.customised-remind-course-settings').css("display", "none")

  $('#toggle-new-course-custom').click (event) ->
    $('#new-course-email-customisation').toggle()

  $('#course_new_course_email_type').change (event) ->
    if $(event.target).val() == "Customise"
      $('.customised-new-course-settings').css("display", "block")
    else
      $('.customised-new-course-settings').css("display", "none")

  $('.send-test-invite').click (event) ->
    $(event.target).css("opacity", "0.5")
    $(event.target).css("pointer-events", "none")
    email_type = $(event.target).attr("data-email-type")
    if email_type == "invite"
      subject = $($('input[id^="course_invite_email[subject]"]')[0]).val()
      header = $($('input[id^="course_invite_email[header]"]')[0]).val()
      button = $($('input[id^="course_invite_email[button]"]')[0]).val()
      body = $($('textarea[id^="course_invite_email[body]"]')[0]).val()
    else if email_type == "welcome"
      subject = $($('input[id^="course_welcome_email[subject]"]')[0]).val()
      header = $($('input[id^="course_welcome_email[header]"]')[0]).val()
      button = $($('input[id^="course_welcome_email[button]"]')[0]).val()
      body = {}
      body['upper'] = $($('textarea[id^="course_welcome_email[body][upper]"]')[0]).val()
      body['lower'] = $($('textarea[id^="course_welcome_email[body][lower]"]')[0]).val()
    else if email_type == "reset_password"
      subject = $($('input[id^="course_reset_password_email[subject]"]')[0]).val()
      header = $($('input[id^="course_reset_password_email[header]"]')[0]).val()
      body = {}
      body['upper'] = $($('textarea[id^="course_reset_password_email[body][upper]"]')[0]).val()
      body['lower'] = $($('textarea[id^="course_reset_password_email[body][lower]"]')[0]).val()
      button = $($('input[id^="course_reset_password_email[button]"]')[0]).val()
    else if email_type == "manager_following"
      subject = $($('input[id^="manager_following_email_subject"]')[0]).val()
      header = $($('input[id^="manager_following_email_header"]')[0]).val()
      body = $($('textarea[id^="manager_following_email_body"]')[0]).val()
      button = $($('input[id^="manager_following_email_button"]')[0]).val()
    else if email_type == "welcome_manager"
      subject = $($('input[id^="welcome_manager_email_subject"]')[0]).val()
      header = $($('input[id^="welcome_manager_email_header"]')[0]).val()
      body = {}
      body['upper'] = $($('textarea[id^="welcome_manager_email_body_upper"]')[0]).val()
      body['lower'] = $($('textarea[id^="welcome_manager_email_body_lower"]')[0]).val()
      button = $($('input[id^="welcome_manager_email_button"]')[0]).val()
    else if email_type == "invite_manager"
      subject = $($('input[id^="invite_manager_email_subject"]')[0]).val()
      header = $($('input[id^="invite_manager_email_header"]')[0]).val()
      body = $($('textarea[id^="invite_manager_email_body"]')[0]).val()
      button = $($('input[id^="invite_manager_email_button"]')[0]).val()
    else if email_type == "before_user_first_day"
      subject = $($('input[id^="course_before_user_first_day_email[subject]"]')[0]).val()
      header = $($('input[id^="course_before_user_first_day_email[header]"]')[0]).val()
      body = $($('textarea[id^="course_before_user_first_day_email[body]"]')[0]).val()
      button = $($('input[id^="course_before_user_first_day_email[button]"]')[0]).val()
    else if email_type == "finished_course"
      l_id = $('#email_language_id').val() || $('#course_lang_id').val()
      subject = $($("input[id^='course_finished_course_email[#{l_id}][subject]']")[0]).val()
      header = $($("input[id^='course_finished_course_email[#{l_id}][header]']")[0]).val()
      body = $($("textarea[id^='course_finished_course_email[#{l_id}][body]']")[0]).val()
      button = $($("input[id^='course_finished_course_email[#{l_id}][button]']")[0]).val()
    else if email_type == "time_based_workflow"
      parent = $(this).parents('.notification-message-container')
      subject = parent.find('#workflow_notify_subject').val()
      header = parent.find('#workflow_notify_header').val()
      body   = parent.find('#workflow_notify_content').val();      
    else if email_type == "inactive_user"
      l_id = $('#email_language_id').val() || $('#course_lang_id').val()
      subject = $($("input[id^='course_inactive_user_email[#{l_id}][subject]']")[0]).val()
      header = $($("input[id^='course_inactive_user_email[#{l_id}][header]']")[0]).val()
      body = {}
      body['upper'] = $($("textarea[id^='course_inactive_user_email[#{l_id}][body][upper]']")[0]).val()
      body['lower'] = $($("textarea[id^='course_inactive_user_email[#{l_id}][body][lower]']")[0]).val()
      button = $($("input[id^='course_inactive_user_email[#{l_id}][button]']")[0]).val()
    else if email_type == "story_available"
      l_id = $('#email_language_id').val() || $('#course_lang_id').val()
      subject = $($("input[id^='course_story_available_email[#{l_id}][subject]']")[0]).val()
      header = $($("input[id^='course_story_available_email[#{l_id}][header]']")[0]).val()
      body = $($("textarea[id^='course_story_available_email[#{l_id}][body]']")[0]).val()
      button = $($("input[id^='course_story_available_email[#{l_id}][button]']")[0]).val()
    else if email_type == "remind_course"
      l_id = $('#email_language_id').val() || $('#course_lang_id').val()
      subject = $($("input[id^='course_remind_course_email[#{l_id}][subject]']")[0]).val()
      header = $($("input[id^='course_remind_course_email[#{l_id}][header]']")[0]).val()
      body = $($("textarea[id^='course_remind_course_email[#{l_id}][body]']")[0]).val()
      button = $($("input[id^='course_remind_course_email[#{l_id}][button]']")[0]).val()
    else if email_type == "new_course"
      l_id = $('#email_language_id').val() || $('#course_lang_id').val()
      subject = $($("input[id^='course_new_course_email[#{l_id}][subject]']")[0]).val()
      header = $($("input[id^='course_new_course_email[#{l_id}][header]']")[0]).val()
      body = $($("textarea[id^='course_new_course_email[#{l_id}][body]']")[0]).val()
      button = $($("input[id^='course_new_course_email[#{l_id}][button]']")[0]).val()

    # Send as body params: the WAF blocks large/link-containing query strings.
    $.post($(event.target).attr("data-url-path"), {
      email_type:    email_type
      email_subject: subject
      email_header:  header
      email_body:    if typeof(body) == 'object' then JSON.stringify(body) else body
      email_button:  button
    }).done(
      (data) ->
        alert "Please check your mailbox."
        $(event.target).css("opacity", "1")
        $(event.target).css("pointer-events", "all")
      ).fail(
      (error) ->
        alert "Something went wrong. Please try again later."
        $(event.target).css("opacity", "1")
        $(event.target).css("pointer-events", "all")
      )

  $('#add_course_languages').change (event) ->
    val = $(event.target).val()
    if val != "0"
      selected = $(event.target).find('option:selected')
      language_id = selected.attr("data-language-id")
      dup = $('#add-new-language-row').clone()
      $(dup).attr("id", "")
      $(dup).find('.language-name').html(val)
      $($(dup).find('.flag-icon')[0]).addClass(selected.attr("data-flag-class"))
      $(dup).find('#course_language_default_0').val(language_id)
      $(dup).find('#course_language_default_0').attr("id", "course_language_default_" + language_id)
      $(dup).find("label[for='course_language_default_0']").html(language_id)
      $(dup).find("label[for='course_language_default_0']").attr("for", "course_language_default_" + language_id)
      $(dup).find('#course_language_status_0_chosen').css("display", "none")
      $(dup).find('#course_language_status_0').chosen({width: '100%'})
      $(dup).find('#course_language_status_0').attr("id", "course_language_status_" + language_id)
      $(dup).find('#course_language_status_0_chosen').attr("id", "course_language_status_" + language_id + "_chosen")

      $('#add-new-language-row').parent().append(dup)
      $(dup).css("display", "table-row")
      selected.css("display", "none")
      $(event.target).val("0")
      $(event.target).trigger("chosen:updated")

      $(dup).find('.remove-course-language').click ->
        remove_course_language_listener(this)

  $('.remove-course-language').click ->
    remove_course_language_listener(this)

  $(".remove-course-marker-file").click ->
    $(this).siblings("input[type='file']").val("")

  $("a[href='#courseMarkerModal']").click ->
    $("#courseMarkerModal").openModal()
    $(".select-dropdown").hide()

  $("a[href='#order-courses']").click ->
    $("#order-courses").openModal()
    $('.course-sortable').sortable ->
      cursor: "move"

  $('form[id="update_stylesheet"]').submit (e) ->
    e.preventDefault()
    application_player_logo = ''
    application_player_background = ''

    if $(e.target).children(".organization-stylesheet").children(".q3").children(".upload-preview-application-player-logo").find("img").attr('src') != undefined && $(e.target).children(".organization-stylesheet").children(".q3").children(".upload-preview-application-player-logo").find("img").attr('src').indexOf("base64") != -1
      application_player_logo = $(e.target).children(".organization-stylesheet").children(".q3").children(".upload-preview-application-player-logo").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")

    else if !(!!$(e.target).children(".organization-stylesheet").children(".q3").children(".upload-preview-application-player-logo").find("img").attr('src'))
      application_player_logo = 'null'

    if $(e.target).children(".organization-stylesheet").children(".q2").children(".upload-preview-application-player-background").find("img").attr('src') != undefined &&  $(e.target).children(".organization-stylesheet").children(".q2").children(".upload-preview-application-player-background").find("img").attr('src').indexOf("base64") != -1
      application_player_background = $(e.target).children(".organization-stylesheet").children(".q2").children(".upload-preview-application-player-background").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")

    else if !(!!$(e.target).children(".organization-stylesheet").children(".q2").children(".upload-preview-application-player-background").find("img").attr('src'))
      application_player_background = 'null'

    form_data =
      'application[player_logo][base64]': application_player_logo
      'application[player_background][base64]': application_player_background
      'application[player_logo][filetype]': fileObject.filetype_player_logo
      'application[player_logo][filename]': fileObject.filename_player_logo
      'application[player_background][filetype]': fileObject.filetype_player_background
      'application[player_background][filename]': fileObject.filename_player_background

      'link_course': $('#link_course').val()
      'copy-course-styling': $('#copy-course-styling').val()

      'application[stylesheet][title-font]': $(e.target).children('.application-stylesheet').children('.application-title-font').children('#application_stylesheet_title-font').val()
      'application[stylesheet][title-weight]': $(e.target).children('.application-stylesheet').children('.application-title-weight').children('#application_stylesheet_title-weight').val()
      'application[stylesheet][title-color]': $(e.target).children('.application-stylesheet').children('.application-title-color').children().last().children('#application_stylesheet_title-color').val()
      'application[stylesheet][title-size]': $(e.target).children('.application-stylesheet').children('.application-title-size').children('#application_stylesheet_title-size').val()

      'application[stylesheet][description-font]': $(e.target).children('.application-stylesheet').children('.application-description-font').children('#application_stylesheet_description-font').val()
      'application[stylesheet][description-color]': $(e.target).children('.application-stylesheet').children('.application-description-color').children().last().children('#application_stylesheet_description-color').val()
      'application[stylesheet][description-size]': $(e.target).children('.application-stylesheet').children('.application-description-size').children('#application_stylesheet_description-size').val()

      'application[stylesheet][answers-font]': $(e.target).children('.application-stylesheet').children('.application-answers-font').children('#application_stylesheet_answers-font').val()
      'application[stylesheet][answers-color]': $(e.target).children('.application-stylesheet').children('.application-answers-color').children().last().children('#application_stylesheet_answers-color').val()
      'application[stylesheet][answers-size]': $(e.target).children('.application-stylesheet').children('.application-answers-size').children('#application_stylesheet_answers-size').val()

      'application[stylesheet][thumb]': $(e.target).children('.application-stylesheet').children('.application-thumb').children().last().children('#application_stylesheet_thumb').val()
      'application[stylesheet][thumb-font-color]': $(e.target).children('.application-stylesheet').children('.application-thumb-font-color').children().last().children('#application_stylesheet_thumb-font-color').val()

      'application[stylesheet][image-border]': $(e.target).children('.application-stylesheet').children('.application-image-border').children().last().children('#application_stylesheet_image-border').val()
      'application[stylesheet][image-thickness]': $(e.target).children('.application-stylesheet').children('.application-image-thickness').children('#application_stylesheet_image-thickness').val()

      'application[stylesheet][checkbox-border]': $(e.target).children('.application-stylesheet').children('.application-checkbox-border').children().last().children('#application_stylesheet_checkbox-border').val()
      'application[stylesheet][checkbox-check]': $(e.target).children('.application-stylesheet').children('.application-checkbox-check').children().last().children('#application_stylesheet_checkbox-check').val()
      'application[stylesheet][checkbox-thickness]': $(e.target).children('.application-stylesheet').children('.application-checkbox-thickness').children('#application_stylesheet_checkbox-thickness').val()

      'application[stylesheet][sideboxes]': $(e.target).children('.application-stylesheet').children('.application-sideboxes').children().last().children('#application_stylesheet_sideboxes').val()
      'application[stylesheet][middlebox]': $(e.target).children('.application-stylesheet').children('.application-middlebox').children().last().children('#application_stylesheet_middlebox').val()

      'application[stylesheet][background]': $(e.target).children(".organization-stylesheet").find(".application-background-color").children().last().children('#application_stylesheet_background').val()
      'application[stylesheet][topbar]': $(e.target).children(".application-stylesheet").children(".application-topbar").children().last().children('#application_stylesheet_topbar').val()
      'application[stylesheet][topbar-bottom]': $(e.target).children(".application-stylesheet").children(".application-topbar-bottom").children().last().children('#application_stylesheet_topbar-bottom').val()
      'application[stylesheet][topbar-text]': $(e.target).children(".application-stylesheet").children(".application-topbar-text").children().last().children('#application_stylesheet_topbar-text').val()
      'application[stylesheet][progressbar]': $(e.target).children(".application-stylesheet").children(".application-progressbar").children().last().children('#application_stylesheet_progressbar').val()
      'application[stylesheet][buttons]': $(e.target).children(".application-stylesheet").children(".application-buttons").children().last().children('#application_stylesheet_buttons').val()
      'application[stylesheet][buttons-text]': $(e.target).children(".application-stylesheet").children(".application-buttons-text").children().last().children('#application_stylesheet_buttons-text').val()
      'application[stylesheet][info-color]': $(e.target).children(".application-stylesheet").children(".application-info-color").children().last().children('#application_stylesheet_info-color').val()
      'application[stylesheet][correct-box]': $(e.target).children(".application-stylesheet").children(".application-correct-box").children().last().children('#application_stylesheet_correct-box').val()
      'application[stylesheet][incorrect-box]': $(e.target).children(".application-stylesheet").children(".application-incorrect-box").children().last().children('#application_stylesheet_incorrect-box').val()
      'application[stylesheet][neutral-box]': $(e.target).children(".application-stylesheet").children(".application-neutral-box").children().last().children('#application_stylesheet_neutral-box').val()
      'application[stylesheet][scrollbar-color]': $(e.target).children(".application-stylesheet").children(".application-scrollbar-color").children().last().children('#application_stylesheet_scrollbar-color').val()
      'application[stylesheet][menu]': $(e.target).children(".application-stylesheet").children(".application-menu").children().last().children('#application_stylesheet_menu').val()
      'application[stylesheet][menu-selected]': $(e.target).children(".application-stylesheet").children(".application-menu-selected").children().last().children('#application_stylesheet_menu-selected').val()
      'application[stylesheet][menu-lip]': $(e.target).children(".application-stylesheet").children(".application-menu-lip").children().last().children('#application_stylesheet_menu-lip').val()
      'application[stylesheet][menu-icon]': $(e.target).children(".application-stylesheet").children(".application-menu-icon").children().last().children('#application_stylesheet_menu-icon').val()
      'application[stylesheet][menu-text]': $(e.target).children(".application-stylesheet").children(".application-menu-text").children().last().children('#application_stylesheet_menu-text').val()
      'application[stylesheet][story-background]': $(e.target).children(".application-stylesheet").children(".story-background").children().last().children('#application_stylesheet_story-background').val()
      'application[stylesheet][story-font]': $(e.target).children(".application-stylesheet").children(".story-font").children().last().children('#application_stylesheet_story-font').val()
      'application[stylesheet][story-selected]': $(e.target).children(".application-stylesheet").children(".story-selected").children().last().children('#application_stylesheet_story-selected').val()

      'authenticity_token': $('input[name=authenticity_token]').val()

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      data: form_data,
      dataType: 'script',

    ).done((data, textStatus, jqXHR) ->
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert ("Name can't be blank")
      return
    )
    true

  $(".edit-application-player-background-modal").click (event) ->
    cropbox = '#application_edit_player_background_cropbox' + "_" + $((event.target)).attr("id")
    $(cropbox).attr "src", $($(event.target)[0]).parent().children(".upload-preview-application-player-background").find("img").attr("src")

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().children(".upload-preview-application-player-background").addClass "upload-preview"
    $('#editCropApplicationPlayerBackgroundModal-' + $((event.target)).attr("id")).find(".upload-preview-application-player-background").addClass "upload-preview"

    instantiateDarkroom(cropbox, '#editCropApplicationPlayerBackgroundModal-' + $((event.target)).attr("id"), '.croppie-background-org')
    $($(this).attr('href')).openModal({
      complete: ->
        $(".darkroom-image-container").remove()
    })
    return

  $('.back-application-player-background').click (event) ->
    $('body').prop('scrollTop', 0)
    close = '#editCropApplicationPlayerBackgroundModal-' + $((event.target)).attr("id")
    open = '#organizationStylingModal'
    $('.darkroom-image-container').remove()
    $(close).closeModal();
    $(open).openModal();
    return

  $(".edit-application-player-background-file").change (event) ->
    file_preview = $(event.target).siblings(".upload-preview-application-player-background").find("img")
    $(event.target).siblings(".edit-application-player-background-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_player_background = file.type;
    fileObject.filename_player_background = file.name;

    return if fileSizeNotInLimit(file,event,".edit-application-player-background-modal",APPLICATION_FILE_LIMITS["player_background"])

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64

      return
    reader.readAsDataURL file
    return

  $(".edit-application-player-logo-file").change (event) ->
    file_preview = $(event.target).siblings(".upload-preview-application-player-logo").find("img")
    $(event.target).siblings(".edit-application-player-logo-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_player_logo = file.type;
    fileObject.filename_player_logo = file.name;

    return if fileSizeNotInLimit(file,event,".edit-application-player-logo-modal",APPLICATION_FILE_LIMITS["player_logo"])

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64

      return
    reader.readAsDataURL file
    return

  $(".close-reveal-modal[modal]").click ->
    $("##{$(this).attr('modal')}").closeModal()

  $(".remove-application-player-background").click ->
    $(".edit-application-player-background-file").val("")
    $(".upload-preview-application-player-background > img").attr("src","")

  $(".remove-application-player-logo").click ->
    $(".edit-application-player-logo-file").val("")
    $(".upload-preview-application-player-logo > img").attr("src","")

  $(".edit-application-player-logo-modal").click (event) ->
    cropbox = '#application_edit_player_logo_cropbox' + "_" + $((event.target)).attr("id")
    $(cropbox).attr "src", $($(event.target)[0]).parent().children(".upload-preview-application-player-logo").find("img").attr("src")

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().children(".upload-preview-application-player-logo").addClass "upload-preview"
    $('#editCropApplicationPlayerLogoModal-' + $((event.target)).attr("id")).find(".upload-preview-application-player-logo").addClass "upload-preview"

    instantiateDarkroom(cropbox, '#editCropApplicationPlayerLogoModal-' + $((event.target)).attr("id"), '.croppie-logo-org')
    $($(this).attr('href')).openModal({
      complete: ->
        $(".darkroom-image-container").remove()
    })
    return

  $('.back-application-player-logo').click (event) ->
    $('body').prop('scrollTop', 0)
    close = '#editCropApplicationPlayerLogoModal-' + $((event.target)).attr("id")
    open = '#organizationStylingModal'
    $('.darkroom-image-container').remove()
    $(close).closeModal();
    $(open).openModal();
    return

  $(".blueprint-box").click ->
    $("#copy-course-styling").val($(this).children("#blueprint-course").val())
    elem = $(this)
    $(".blueprint-box").each (index,item) ->
      unless elem[0] == $(item)[0] then $(item).css("border-color", "#e2e2e2") else $(item).css("border-color", "#3ca0e8")

  $("#blueprint").click (event) ->
    if $("#blueprint").find('.owl-wrapper-outer').length == 0
      $('#blueprint').children().css("border-color", "#e2e2e2")
    else
      $('#blueprint').find('.blueprint-box').css("border-color", "#e2e2e2")
    if event.target.tagName == 'IMG'
      $(event.target).parent().parent().css("border-color", "#3ca0e8")
      $("#createModal").find("#blueprint-name").val($(event.target).parent().parent().find('h6').html())

    else if event.target.tagName == 'H6'
      $(event.target).parent().css("border-color", "#3ca0e8")
      $("#createModal").find("#blueprint-name").val($(event.target).parent().find('h6').html())

    else if event.target.tagName == 'DIV'
      $(event.target).css("border-color", "#3ca0e8")
      $("#createModal").find("#blueprint-name").val($(event.target).find('h6').html())
    return

  $("#styling").click (event) ->
    if event.target.tagName == 'H6'
      $('#styling').find('.owl-item').children().css("border-color", "#e2e2e2")
      $(event.target).parent().css("border-color", "#3ca0e8")
      $("#createModal").find("#stylesheet-name").val($(event.target).parent().find('h6').html())

    else if event.target.tagName == 'DIV'
      if $($(event.target)[0]).hasClass('blueprint-box')
        $('#styling').find('.owl-item').children().css("border-color", "#e2e2e2")
        $(event.target).css("border-color", "#3ca0e8")
        $("#createModal").find("#stylesheet-name").val($(event.target).find('h6').html())
      else
        $('#styling').find('.owl-item').children().css("border-color", "#e2e2e2")
        $(event.target).parent().css("border-color", "#3ca0e8")
        $("#createModal").find("#stylesheet-name").val($(event.target).parent().find('h6').html())
    return

  toggleAppStyling = () ->
    if $('#link_course').val() == ''
      $('#course-styling').hide()
      $('.organization-stylesheet').show()
      $(".blueprint-box").css("border-color", "#e2e2e2")
      $("#copy-course-styling").val("")
    else
      $('#course-styling').show()
      $('.organization-stylesheet').hide()
    return

  $('#link_course').change (event) ->
    toggleAppStyling()
    return

  $('.toggle-org-styling').click (event) ->
    toggleAppStyling()
    return

  $("a[href='#organizationStylingModal']").click ->
    $($(this).attr('href')).openModal({
      complete: ->
        $(".darkroom-image-container").remove()
    })
    $("#{$(this).attr('href')} .select-dropdown").hide()
    $("#{$(this).attr('href')} #course-styling").hide()

  $("a[href='#moveModal']").click ->
    $("#moveModal").openModal()
    $("#moveModal .select-dropdown").hide()

  $('.modal-for-course-size').click (event) ->
    $($(event.target).attr("data_link")).openModal()

  $('.modal-for-course-delete').click (event) ->
    $($(event.target).attr("data_link")).openModal()

  $('.modal-for-course-copy').click (event) ->
    $("#copyModal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    $($(event.target).attr("data_link")).openModal()

  $('.modal-for-course-translate').click (event) ->
    $("#translateModal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    $($(event.target).attr("data_link")).openModal()

  $('.modal-for-course-tags').click (event) ->
    $('.tag-close').css("background", "none")
    $('.tag-label').css("background", "none")
    $($(event.target).attr("data_link")).openModal()

  $('.course-runtime-listener').change (event) ->
    runtime = parseInt($(event.target).val())
    select_1 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_1').attr("id"))
    select_2 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_2').attr("id"))
    select_3 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_3').attr("id"))
    $(event.target).parents().find('#course_remind_completion_runtime_1').empty()
    $(event.target).parents().find('#course_remind_completion_runtime_2').empty()
    $(event.target).parents().find('#course_remind_completion_runtime_3').empty()

    selects = [select_1, select_2, select_3]

    for select in selects
      opt = document.createElement('option')
      opt.value = "-"
      opt.innerHTML = "-"
      select.appendChild opt

    if runtime > 0
      for i in [1..runtime]
        opt = document.createElement('option')
        opt.value = i
        opt.innerHTML = i
        select_1.appendChild opt

    $(select_1).trigger("chosen:updated");
    $(select_2).trigger("chosen:updated");
    $(select_3).trigger("chosen:updated");

  $('.course-runtime-1').change (event) ->
    runtime_start = parseInt($(event.target).val()) + 1
    runtime_final = parseInt($(event.target).parents().find('#course_runtime').val())
    select_2 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_2').attr("id"))
    select_3 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_3').attr("id"))
    $(event.target).parents().find('#course_remind_completion_runtime_2').empty()
    $(event.target).parents().find('#course_remind_completion_runtime_3').empty()

    selects = [select_2, select_3]

    for select in selects
      opt = document.createElement('option')
      opt.value = "-"
      opt.innerHTML = "-"
      select.appendChild opt

    if runtime_start <= runtime_final
      for i in [runtime_start..runtime_final]
        opt = document.createElement('option')
        opt.value = i
        opt.innerHTML = i
        select_2.appendChild opt

    $(select_2).trigger("chosen:updated");
    $(select_3).trigger("chosen:updated");

  $('.course-runtime-2').change (event) ->
    runtime_start = parseInt($(event.target).val()) + 1
    runtime_final = parseInt($(event.target).parents().find('#course_runtime').val())
    select_3 = document.getElementById($(event.target).parents().find('#course_remind_completion_runtime_3').attr("id"))
    $(event.target).parents().find('#course_remind_completion_runtime_3').empty()

    opt = document.createElement('option')
    opt.value = "-"
    opt.innerHTML = "-"
    select_3.appendChild opt

    if runtime_start <= runtime_final
      for i in [runtime_start..runtime_final]
        opt = document.createElement('option')
        opt.value = i
        opt.innerHTML = i
        select_3.appendChild opt

    $(select_3).trigger("chosen:updated");

  $(document).on('change', '.upload-course-image-file', (event) ->
    file_preview = $(this).parents('.image-container').find(".upload-preview-course-image").find("img")
    $(this).parents('.image-container').find(".edit-course-image-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-image-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filename_image = file.name;
    fileObject.filetype_image = file.type;
    language = $('#course_name_language').val();
    course_images[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".edit-course-image-modal",COURSE_FILE_LIMITS["image"])
    $(this).parents('.image-container').find('.remove-course-image').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-course-image').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return
  )

  $(document).on('click', '.remove-course-image', (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-course-image').find("img").attr("src", null)
    $($(event.target)[0]).parents('.image-container').find('.edit-button-container .edit-alt-text-image-modal').css("display", "none")
    $($(event.target)[0]).parents('.image-container').find('.edit-course-image-modal').css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return
  )

  $(document).on('click', '.edit-course-image-modal', (event) ->
    $("#image_modal").openModal();
    $("#image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');
    cropbox = '#course_edit_image_cropbox'
    $(cropbox).attr "src", $($(event.target)[0]).siblings("img").attr("src")

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype_image && details.length > 1
      fileObject.filename_image = details[0]
      fileObject.filetype_image = details[1].slice(1)
      language = $('#course_name_language').val();
      course_images[language] = {name: details[0], type: details[1].slice(1)}

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().addClass "upload-preview"
    $('#editCropCourseImageModal').find(".upload-preview-course-image").addClass "upload-preview"

    element = $(cropbox)
    modal = '#editCropCourseImageModal'
    croppie = '.croppie-image'

    croppie_course = $(croppie).croppie({
      viewport: {
        width: parseInt(element.attr('data-width')),
        height: parseInt(element.attr('data-height'))
      }
    });

    if $(modal).find('.croppie-container').length > 1
      $(modal).find('.croppie-container:last').appendTo("#{modal} .main-image-container")
      $(modal).find('.croppie-container:first').remove()
    return
  )

  $(".upload-course-background-file").change (event) ->
    file_preview = $(event.target).parents('.image-container').find(".upload-preview-course-background").find("img")
    $(this).parents('.image-container').find(".edit-course-background-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-background-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_background = file.type;
    fileObject.filename_background = file.name;
    language = $('#course_name_language').val();
    course_backgrounds[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".edit-course-background-modal",COURSE_FILE_LIMITS["background"])
    $(this).parents('.image-container').find('.remove-course-background').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-course-background').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return

  $('.remove-course-background').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-course-background').find("img").attr("src", null)
    $($(event.target)[0]).parents('.image-container').find('.edit-alt-text-background-modal').css("display", "none")
    $($(event.target)[0]).parents('.image-container').find('.edit-course-background-modal').css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return

  $(".edit-course-background-modal").click (event) ->
    $("#background_modal").openModal();
    $("#background_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype_background && details.length > 1
      fileObject.filetype_background = details[1].slice(1)
      fileObject.filename_background = details[0]
      language = $('#course_name_language').val();
      course_backgrounds[language] = {name: details[0], type: details[1].slice(1)}
    return

  $(".upload-course-logo-file").change (event) ->
    file_preview = $(event.target).parents('.image-container').find(".upload-preview-course-logo").find("img")
    $(this).parents('.image-container').find(".edit-course-logo-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-logo-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_logo = file.type;
    fileObject.filename_logo = file.name;
    language = $('#course_name_language').val();
    course_logos[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".edit-course-logo-modal",COURSE_FILE_LIMITS["logo"])
    $(this).parents('.image-container').find('.remove-course-logo').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-course-logo').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return

  $('.remove-course-logo').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-course-logo').find("img").attr("src", null)
    $($(event.target)[0]).parents('.image-container').find('.edit-alt-text-logo-modal').css("display", "none")
    $($(event.target)[0]).parents('.image-container').find('.edit-course-logo-modal').css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return

  $(".edit-course-logo-modal").click (event) ->
    $("#logo_modal").openModal();
    $("#logo_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype_logo && details.length > 1
      fileObject.filetype_logo = details[1].slice(1).toLowerCase()
      fileObject.filename_logo = details[0]
      language = $('#course_name_language').val();
      course_logos[language] = {name: details[0], type: details[1].slice(1)}
    return

  $(".edit-course-welcome-image").change (event) ->
    file_preview = $(event.target).parents('.image-container').find(".upload-preview-course-welcome-image").find("img")
    $(this).parents('.image-container').find(".edit-course-welcome-image-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-welcome-image-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_welcome_image = file.type;
    fileObject.filename_welcome_image = file.name;
    language = $('#course_name_language').val();
    course_welcome_images[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".edit-course-welcome-image-modal",COURSE_FILE_LIMITS["welcome_image"])
    $(this).parents('.image-container').find('.remove-course-welcome-image').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-course-welcome-image').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return

  $(".edit-course-welcome-video").change (event) ->
    if $(this)[0].files[0] && (($(this)[0].files[0].size) / 1024 / 1024) > 90
      $(this).val('')
      alert "Uploaded video exceeds maximum file size of 90MB"
    else if $(this)[0].files[0]
      file_preview = $(event.target).parents('.image-container').find(".upload-preview-course-welcome-video").find("video")

      input = $(event.currentTarget)
      file = input[0].files[0]
      fileObject.filetype_welcome_video = file.type;
      fileObject.filename_welcome_video = file.name;
      language = $('#course_name_language').val();
      course_welcome_videos[language] = {name: file.name, type: file.type}

      $(this).parents('.image-container').find('.remove-course-welcome-video').parent('.cs-trash').css("opacity", 1)
      $(this).parents('.image-container').find('.remove-course-welcome-video').parent('.cs-trash').css("pointer-events", "all")
      $(this).parents('.image-container').find('.welcome-video-thumbnail-container').css("display", "block")

      reader = new FileReader()
      reader.onload = (e) ->
        image_base64 = e.target.result
        image_base64 = image_base64.replace("quicktime","mp4")
        file_preview.get(0).removeAttribute("crossorigin");
        file_preview.attr "src", image_base64
        file_preview.attr "poster", ''
        return
      reader.readAsDataURL file
    return

  $(".edit-course-welcome-image-modal").click (event) ->
    $("#welcome_image_modal").openModal();
    $("#welcome_image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype_welcome_image && details.length > 1
      fileObject.filetype_welcome_image = details[1].slice(1)
      fileObject.filename_welcome_image = details[0]
      language = $('#course_name_language').val();
      course_welcome_images[language] = {name: details[0], type: details[1].slice(1)}

  $('.remove-course-welcome-image').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-course-welcome-image').find("img").attr("src", null)
    $($(event.target)[0]).parents('.image-container').find('.edit-alt-text-welcome-image-modal').css("display", "none")
    $($(event.target)[0]).parents('.image-container').find('.edit-course-welcome-image-modal').css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return

  $('.remove-course-welcome-video').click (event) ->
    main_vid                                  = $($(event.target)[0]).parents('.image-container').find('.upload-preview-course-welcome-video').find("video")
    thumbnail_container                       = $($(event.target)[0]).parents('.image-container').find('.welcome-video-thumbnail-container')
    thumbnail                                 = thumbnail_container.find("img")
    language                                  = $('#course_name_language').val();
    course_welcome_video_thumbnails[language] = { content: null }
    main_vid.attr("src", '')
    main_vid.attr("src",null)
    thumbnail.attr("src",null)
    thumbnail_container.css("display","none")
    main_vid.attr("poster", '')
    main_vid.find('source').attr("src",null)
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return

  $('.subtitle_file_remove_btn').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('#welcome_video_subtitles').val($(this).attr('data-remote-remove'))
    $($(event.target)[0]).parents('.image-container').find('.edit-course-welcome-video-subtitles').val(null)
    $($(event.target)[0]).parents('.image-container').find('.video-subtitles-file').find('h6').text('')
    $(this).css("display",'none')
    return

  $(".capture-thumbnail-welcome-modal").click (event) ->
    video = $(this).parent().siblings('.upload-preview-course-welcome-video').find('video').get(0)
    if video != undefined
      $(this).parent().find('.display-thumbnail').html('')
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      context.canvas.width = video.videoWidth
      context.canvas.height = video.videoHeight
      context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      try
        dataURL = canvas.toDataURL()
        img = document.createElement('img')
        img.setAttribute('src', dataURL)
        language = $('#course_name_language').val();
        course_welcome_video_thumbnails[language] = {content: dataURL.replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")}
        $(this).parent().find('.display-thumbnail').html(img)
        $(this).parent().find('.display-thumbnail').find('img').css("max-width", "100%")
        $(this).parent().find('.thumbnail-preview-text').show()
      catch err
        console.log (err.message)

  $('.course-welcome-file').change (event) ->
    if $(this).val() == 'Image'
      $('#course-welcome-text-'+$('#course_welcome_text_language').val()).show()
      $('.welcome-video-thumbnail-container').hide()
      $('#course_welcome_video_'+$('#course_welcome_text_language').val()).parent().hide()
      $('.course-welcome-video-'+$('#course_welcome_text_language').val()).parent().hide()
      $('.disabled-direct-upload-welcome-video_'+$('#course_welcome_text_language').val()).hide()
      $('#course_welcome_video_subtitles_'+$('#course_welcome_text_language').val()).parent().hide()
      $('#video-subtitles-file-'+$('#course_welcome_text_language').val()).hide()
      $("#welcome_video_autoplay_"+$('#course_welcome_text_language').val()).hide()
      $('.remove-course-welcome-video').parent().hide()
      $('.upload-preview-course-welcome-video').hide()
      $('.remove-course-welcome-image').show()
      $('.upload-preview-course-welcome-image').show()
    else if $(this).val() == 'Video'
      $('#course-welcome-text-'+$('#course_welcome_text_language').val()).show()
      $('.welcome-video-thumbnail-container').show()
      $('#course_welcome_video_'+$('#course_welcome_text_language').val()).parent().show()
      $('.course-welcome-video-'+$('#course_welcome_text_language').val()).parent().show()
      $('.disabled-direct-upload-welcome-video_'+$('#course_welcome_text_language').val()).show()
      $('#course_welcome_video_subtitles_'+$('#course_welcome_text_language').val()).parent().show()
      $('#video-subtitles-file-'+$('#course_welcome_text_language').val()).show()
      $("#welcome_video_autoplay_"+$('#course_welcome_text_language').val()).show()
      $('.remove-course-welcome-video').parent().show()
      $('.upload-preview-course-welcome-video').show()
      $('.remove-course-welcome-image').hide()
      $('.upload-preview-course-welcome-image').hide()
    else if $(this).val() == 'Both'
      $('#course-welcome-text-'+$('#course_welcome_text_language').val()).show()
      $('.welcome-video-thumbnail-container').show()
      $('#course_welcome_video_'+$('#course_welcome_text_language').val()).parent().show()
      $('.course-welcome-video-'+$('#course_welcome_text_language').val()).parent().show()
      $('.disabled-direct-upload-welcome-video_'+$('#course_welcome_text_language').val()).show()
      $('#course_welcome_video_subtitles_'+$('#course_welcome_text_language').val()).parent().show()
      $('#video-subtitles-file-'+$('#course_welcome_text_language').val()).show()
      $("#welcome_video_autoplay_"+$('#course_welcome_text_language').val()).show()
      $('.remove-course-welcome-video').parent().show()
      $('.upload-preview-course-welcome-video').show()
      $('.remove-course-welcome-image').show()
      $('.upload-preview-course-welcome-image').show()
    else
      $('#course-welcome-text-'+$('#course_welcome_text_language').val()).show()
      $('.welcome-video-thumbnail-container').hide()
      $('#course_welcome_video_'+$('#course_welcome_text_language').val()).parent().hide()
      $('.course-welcome-video-'+$('#course_welcome_text_language').val()).parent().hide()
      $('.disabled-direct-upload-welcome-video_'+$('#course_welcome_text_language').val()).hide()
      $('#course_welcome_video_subtitles_'+$('#course_welcome_text_language').val()).parent().hide()
      $('#video-subtitles-file-'+$('#course_welcome_text_language').val()).hide()
      $("#welcome_video_autoplay_"+$('#course_welcome_text_language').val()).hide()
      $('.remove-course-welcome-video').parent().hide()
      $('.upload-preview-course-welcome-video').hide()
      $('.remove-course-welcome-image').hide()
      $('.upload-preview-course-welcome-image').hide()

  $('.edit-course-welcome-video-subtitles').off("change");
  $(".edit-course-welcome-video-subtitles").change (event) ->
    if $(this)[0].files[0]
      file_preview = $(this).siblings('#welcome_video_subtitles')
      input = $(event.currentTarget)
      file = input[0].files[0]
      language = $('#course_name_language').val()
      course_welcome_video_subtitles[language] = {name: file.name, type: file.type}
      $(this).parents('.image-container').find('.video-subtitles-file').show()
      $(this).parents('.image-container').find('.subtitle_file_remove_btn').show()
      $(this).parents('.image-container').find('.video-subtitles-file').find('h6').text(file.name)

      reader = new FileReader()
      reader.onload = (e) ->
        image_base64 = e.target.result
        file_preview.val image_base64
        return
      reader.readAsDataURL file
    return

  $('.add-wave').click (event) ->
    if (wave_number + 1) <= $('.wave-details').length
      $($('.wave-details')[wave_number]).show()
      wave_number++
      if (wave_number) == $('.wave-details').length
        $(this).parent().css("opacity", "0.5")

  $('.remove-wave').click (event) ->
    $(this).parents('.wave-details').hide()
    $(this).parents('.wave-details').find('.datepicker-wave').val('')
    $(this).parents('.wave-details').find('#course_waves_deleted_').val(true)

  $('form[id^="edit_course_"]').submit (e) ->
    e.preventDefault()
    $('#loading-modal').openModal({dismissible: false})

    index = 0
    $(e.target).children().find(".course-image-uploaded").each ->
      language_id = $($(e.target).children().find(".course-image-uploaded")[index]).data('language-id').toString()
      course_images[language_id] = {} if course_images[language_id] == undefined
      if $($(e.target).children().find(".course-image-uploaded")[index]).find("img").attr('src') != undefined && $($(e.target).children().find(".course-image-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        course_images[language_id]['content'] = $($(e.target).children().find(".course-image-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".course-image-uploaded")[index]).find("img").attr('src') == undefined
        course_images[language_id]['content'] = 'null'
      index++

    index = 0
    $(e.target).children().find(".course-background-uploaded").each ->
      language_id = $($(e.target).children().find(".course-background-uploaded")[index]).data('language-id').toString()
      course_backgrounds[language_id] = {} if course_backgrounds[language_id] == undefined
      if $($(e.target).children().find(".course-background-uploaded")[index]).find("img").attr('src') != undefined && $($(e.target).children().find(".course-background-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        course_backgrounds[language_id]['content'] = $($(e.target).children().find(".course-background-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".course-background-uploaded")[index]).find("img").attr('src') == undefined
        course_backgrounds[language_id]['content'] = 'null'
      index++

    index = 0
    $(e.target).children().find(".course-logo-uploaded").each ->
      language_id = $($(e.target).children().find(".course-logo-uploaded")[index]).data('language-id').toString()
      course_logos[language_id] = {} if course_logos[language_id] == undefined
      if $($(e.target).children().find(".course-logo-uploaded")[index]).find("img").attr('src') != undefined && $($(e.target).children().find(".course-logo-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        course_logos[language_id]['content'] = $($(e.target).children().find(".course-logo-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".course-logo-uploaded")[index]).find("img").attr('src') == undefined
        course_logos[language_id]['content'] = 'null'
      index++

    index = 0
    $(e.target).children().find(".course-welcome-image-uploaded").each ->
      language_id = $($(e.target).children().find(".course-welcome-image-uploaded")[index]).data('language-id').toString()
      course_welcome_images[language_id] = {} if course_welcome_images[language_id] == undefined
      if $($(e.target).children().find(".course-welcome-image-uploaded")[index]).find("img").attr('src') != undefined &&  $($(e.target).children().find(".course-welcome-image-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        course_welcome_images[language_id]['content'] = $($(e.target).children().find(".course-welcome-image-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".course-welcome-image-uploaded")[index]).find("img").attr('src') == undefined
        course_welcome_images[language_id]['content'] = 'null'
      index++

    index = 0
    $(e.target).children().find(".course-welcome-image-uploaded").each ->
      language_id = $($(e.target).children().find(".course-welcome-video-uploaded")[index]).data('language-id').toString()
      course_welcome_videos[language_id] = {} if course_welcome_videos[language_id] == undefined
      if $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").attr('src') != undefined &&  $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").attr('src').indexOf("base64") != -1
        course_welcome_videos[language_id]['content'] = $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").attr('src').replace(/^data:video\/(mp4|mov);base64,/, "")
      else if $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").attr('src') == undefined
        if $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").find("source").attr('src') != undefined && $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").find("source").attr('src').indexOf("base64") != -1
          course_welcome_videos[language_id]['content'] = $(e.target).children().find(".course-welcome-video-uploaded").find("video").find("source").attr('src').replace(/^data:video\/(mp4|mov);base64,/, "")
        else if $($(e.target).children().find(".course-welcome-video-uploaded")[index]).find("video").find('source').attr('src') == undefined
          course_welcome_videos[language_id]['content'] = 'null'
      index++

    index = 0
    $(e.target).children().find(".course-welcome-image-uploaded").each ->
      language_id = $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).data('language-id').toString()
      course_welcome_video_subtitles[language_id] = {} if course_welcome_video_subtitles[language_id] == undefined
      if $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).find("#welcome_video_subtitles").val() != undefined &&  $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).find("#welcome_video_subtitles").val().indexOf("base64") != -1
        subtitle_content = $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).find("#welcome_video_subtitles").val()
        subtitle_content = subtitle_content.replace(/^data:text\/(vtt);base64,/, "").replace(/^data:application\/(octet-stream);base64,/, "")
        if subtitle_content.includes('base64') == true
          course_welcome_video_subtitles[language_id]['content'] = subtitle_content.substring(subtitle_content.lastIndexOf(',') + 1)
        else
            course_welcome_video_subtitles[language_id]['content'] = subtitle_content
      else if $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).find("#welcome_video_subtitles").val() == undefined || $($(e.target).children().find(".course-welcome-video-subtitles-uploaded")[index]).find("#welcome_video_subtitles").val() == 'removed'
        course_welcome_video_subtitles[language_id]['content'] = 'null'
      index++

    if $(e.target).children().find('#course_dashboard_enable').is(':checked')
      dashboard = 1
    else
      dashboard = 0

    if $(e.target).children().find('#course_preboarding_enable').is(':checked')
      preboarding = 1
    else
      preboarding = 0

    if $(e.target).children().find('#course_leaderboard').val() == 'Enable'
      leaderboard = 1
    else
      leaderboard = 0

    if $(e.target).children().find('#course_leaderboard_user_name_criteria').length > 0
      leaderboard_user_name_criteria = $(e.target).children().find('#course_leaderboard_user_name_criteria').val().toLowerCase()
    else
      leaderboard_user_name_criteria = 'display_leaderboard_user_name'

    if $(e.target).children().find('#course_scoring_criteria').length > 0
      scoring_criteria = $(e.target).children().find('#course_scoring_criteria').val().toLowerCase()
    else
      scoring_criteria = 'percentage'

    if $(e.target).children().find('#course_remind_completion_email_enable').is(':checked')
      remind_completion_email = 1
    else
      remind_completion_email = 0

    if $('#course_dashboard_type').val() == "offboarding_dashboard"
      dashboard_type = "offboarding_dashboard"
    else if $('#course_dashboard_type').val() == "simple_dashboard"
      dashboard_type = "simple_dashboard"
    else
      dashboard_type = "onboarding_dashboard"

    if $('[name^="course[invite_email_type]"]').val() == 'Customise'
      invite_email_type = "invite_customise"
    else
      invite_email_type = "invite_default"

    if $('[name^="course[welcome_email_type]"]').val() == 'Customise'
      welcome_email_type = "welcome_customise"
    else
      welcome_email_type = "welcome_default"

    if $('[name^="course[reset_password_email_type]"]').val() == 'Customise'
      reset_password_email_type = "reset_password_customise"
    else
      reset_password_email_type = "reset_password_default"

    if $('[name^="course[manager_following_email_type]"]').val() == 'Customise'
      manager_following_email_type = "manager_following_customise"
    else
      manager_following_email_type = "manager_following_default"

    if $('[name^="course[welcome_manager_email_type]"]').val() == 'Customise'
      welcome_manager_email_type = "welcome_manager_customise"
    else
      welcome_manager_email_type = "welcome_manager_default"

    if $('[name^="course[invite_manager_email_type]"]').val() == 'Customise'
      invite_manager_email_type = "invite_manager_customise"
    else
      invite_manager_email_type = "invite_manager_default"

    if $('[name^="course[before_user_first_day_email_type]"]').val() == 'Customise'
      before_user_first_day_email_type = "before_user_first_day_customise"
    else
      before_user_first_day_email_type = "before_user_first_day_default"

    if $('[name^="course[finished_course_email_type]"]').val() == 'Customise'
      finished_course_email_type = "finished_course_customise"
    else
      finished_course_email_type = "finished_course_default"

    if $('[name^="course[inactive_user_email_type]"]').val() == 'Customise'
      inactive_user_email_type = "inactive_user_customise"
    else
      inactive_user_email_type = "inactive_user_default"

    if $('[name^="course[story_available_email_type]"]').val() == 'Customise'
      story_available_email_type = "story_available_customise"
    else
      story_available_email_type = "story_available_default"

    if $('[name^="course[remind_course_completion_email_type]"]').val() == 'Customise'
      remind_course_email_type = "remind_course_customise"
    else
      remind_course_email_type = "remind_course_default"

    if $('[name^="course[new_course_email_type]"]').val() == 'Customise'
      new_course_email_type = "new_course_customise"
    else
      new_course_email_type = "new_course_default"

    course_languages_status = {}
    for name in $('[name^="course[language_status]"]')
      id = $(name).attr("id")
      key = id.split("_")[id.split("_").length-1]
      val = $(name).val()
      course_languages_status[key] = val

    alt_text_for_images                   = {}
    alt_text_for_logos                    = {}
    alt_text_for_backgrounds              = {}
    alt_text_for_welcome_images           = {}
    asset_id_for_images                   = {}
    asset_id_for_logos                    = {}
    asset_id_for_backgrounds              = {}
    asset_id_for_welcome_images           = {}
    asset_id_for_welcome_video            = {}

    for alt_text in $('input[id^="course_image_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        alt_text_for_images[key] = val

    for alt_text in $('input[id^="course_background_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        alt_text_for_backgrounds[key] = val

    for alt_text in $('input[id^="course_logo_alt_text"]')
      id  = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        alt_text_for_logos[key] = val

    for alt_text in $('input[id^="course_welcome_image_alt_text"]')
      id  = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        alt_text_for_welcome_images[key] = val

    for alt_text in $('input[id^="asset-id-course-image"]')
      id  = $(alt_text).attr("id")
      key = id.split("-").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        asset_id_for_images[key] = val

    for alt_text in $('input[id^="asset-id-course-background"]')
      id = $(alt_text).attr("id")
      key = id.split("-").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        asset_id_for_backgrounds[key] = val

    for alt_text in $('input[id^="asset-id-course-logo"]')
      id  = $(alt_text).attr("id")
      key = id.split("-").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        asset_id_for_logos[key] = val

    for alt_text in $('input[id^="asset-id-course-welcome-image"]')
      id  = $(alt_text).attr("id")
      key = id.split("-").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        asset_id_for_welcome_images[key] = val

    for alt_text in $('input[id^="asset-id-course-welcome-video"]')
      id  = $(alt_text).attr("id")
      key = id.split("-").pop()
      val = $(alt_text).val()
      if !!course_languages_status[key]
        asset_id_for_welcome_video[key] = val

    name_multi = {}
    for name in $('input[id^="course_name_multi"]')
      id = $(name).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = $(name).val()
      if !!course_languages_status[key]
        name_multi[key] = val

    welcome_text_multi = {}
    for name in $('textarea[id^="course_welcome_text_multi"]')
      id = $(name).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = CKEDITOR.instances["course_welcome_text_multi_"+key].getData();
      if !!course_languages_status[key]
        welcome_text_multi[key] = val

    finished_course_email = {}
    for inputField in $('input[id^="course_finished_course_email"], textarea[id^="course_finished_course_email"]')
      id = $(inputField).attr("id")
      match = id.match(/\[(\d+)\]\[(\w+)\]/)
      continue unless match?
      key = match[1]
      type = match[2]
      val = $(inputField).val()
      finished_course_email[key] = {} unless finished_course_email[key]?
      finished_course_email[key][type] = val if val?

    inactive_user_email = {}
    for inputField in $('input[id^="course_inactive_user_email"], textarea[id^="course_inactive_user_email"]')
      id = $(inputField).attr("id")
      match = id.match(/\[(\d+)\]\[(\w+)\](?:\[(\w+)\])?/)
      continue unless match?
      key = match[1]
      type = match[2]
      subtype = match[3]
      val = $(inputField).val()
      inactive_user_email[key] = {} unless inactive_user_email[key]?
      if subtype?
        inactive_user_email[key][type] = {} unless inactive_user_email[key][type]?
        inactive_user_email[key][type][subtype] = val if val?
      else
        inactive_user_email[key][type] = val if val?

    story_available_email = {}
    for inputField in $('input[id^="course_story_available_email"], textarea[id^="course_story_available_email"]')
      id = $(inputField).attr("id")
      match = id.match(/\[(\d+)\]\[(\w+)\]/)
      continue unless match?
      key = match[1]
      type = match[2]
      val = $(inputField).val()
      story_available_email[key] = {} unless story_available_email[key]?
      story_available_email[key][type] = val if val?

    remind_course_email = {}
    for inputField in $('input[id^="course_remind_course_email"], textarea[id^="course_remind_course_email"]')
      id = $(inputField).attr("id")
      match = id.match(/\[(\d+)\]\[(\w+)\]/)
      continue unless match?
      key = match[1]
      type = match[2]
      val = $(inputField).val()
      remind_course_email[key] = {} unless remind_course_email[key]?
      remind_course_email[key][type] = val if val?

    new_course_email = {}
    for inputField in $('input[id^="course_new_course_email"], textarea[id^="course_new_course_email"]')
      id = $(inputField).attr("id")
      match = id.match(/\[(\d+)\]\[(\w+)\]/) 
      continue unless match?
      key = match[1]
      type = match[2]
      val = $(inputField).val()
      new_course_email[key] = {} unless new_course_email[key]?
      new_course_email[key][type] = val if val?

    course_waves = []
    index = 0
    for wave in $('.wave-details')
      id = $(wave).find('#course_waves_id_').val()
      story_id = $(wave).find('#course_waves_story_id_').val()
      start_date = $(wave).find('#course_waves_start_date_').val()
      end_date = $(wave).find('#course_waves_end_date_').val()
      if !!story_id && !!start_date && !!end_date
        course_waves.push({id: id, story_id: story_id, start_date: start_date, end_date: end_date})

    invite_email = {}
    invite_email["subject"] = $($('input[id^="course_invite_email[subject]"]')[0]).val()
    invite_email["header"] = $($('input[id^="course_invite_email[header]"]')[0]).val()
    invite_email["button"] = $($('input[id^="course_invite_email[button]"]')[0]).val()
    invite_email["body"] = $($('textarea[id^="course_invite_email[body]"]')[0]).val()

    welcome_email = {}
    welcome_email["subject"] = $($('input[id^="course_welcome_email[subject]"]')[0]).val()
    welcome_email["header"] = $($('input[id^="course_welcome_email[header]"]')[0]).val()
    welcome_email["button"] = $($('input[id^="course_welcome_email[button]"]')[0]).val()
    welcome_email["body"] = {}
    welcome_email["body"]["upper"] = $($('textarea[id^="course_welcome_email[body][upper]"]')[0]).val()
    welcome_email["body"]["lower"] = $($('textarea[id^="course_welcome_email[body][lower]"]')[0]).val()

    reset_password_email = {}
    reset_password_email["subject"] = $($('input[id^="course_reset_password_email[subject]"]')[0]).val()
    reset_password_email["header"] = $($('input[id^="course_reset_password_email[header]"]')[0]).val()
    reset_password_email["body"] = {}
    reset_password_email["body"]["upper"] = $($('textarea[id^="course_reset_password_email[body][upper]"]')[0]).val()
    reset_password_email["body"]["lower"] = $($('textarea[id^="course_reset_password_email[body][lower]"]')[0]).val()
    reset_password_email["button"] = $($('input[id^="course_reset_password_email[button]"]')[0]).val()

    manager_following_email = {}
    manager_following_email["subject"] = $($('input[id^="course_manager_following_email[subject]"]')[0]).val()
    manager_following_email["header"] = $($('input[id^="course_manager_following_email[header]"]')[0]).val()
    manager_following_email["body"] = $($('textarea[id^="course_manager_following_email[body]"]')[0]).val()
    manager_following_email["button"] = $($('input[id^="course_manager_following_email[button]"]')[0]).val()

    welcome_manager_email = {}
    welcome_manager_email["subject"] = $($('input[id^="course_welcome_manager_email[subject]"]')[0]).val()
    welcome_manager_email["header"] = $($('input[id^="course_welcome_manager_email[header]"]')[0]).val()
    welcome_manager_email["body"] = {}
    welcome_manager_email["body"]["upper"] = $($('textarea[id^="course_welcome_manager_email[body][upper]"]')[0]).val()
    welcome_manager_email["body"]["lower"] = $($('textarea[id^="course_welcome_manager_email[body][lower]"]')[0]).val()
    welcome_manager_email["button"] = $($('input[id^="course_welcome_manager_email[button]"]')[0]).val()

    invite_manager_email = {}
    invite_manager_email["subject"] = $($('input[id^="course_invite_manager_email[subject]"]')[0]).val()
    invite_manager_email["header"] = $($('input[id^="course_invite_manager_email[header]"]')[0]).val()
    invite_manager_email["body"] = $($('textarea[id^="course_invite_manager_email[body]"]')[0]).val()
    invite_manager_email["button"] = $($('input[id^="course_invite_manager_email[button]"]')[0]).val()

    before_user_first_day_email = {}
    before_user_first_day_email["subject"] = $($('input[id^="course_before_user_first_day_email[subject]"]')[0]).val()
    before_user_first_day_email["header"] = $($('input[id^="course_before_user_first_day_email[header]"]')[0]).val()
    before_user_first_day_email["body"] = $($('textarea[id^="course_before_user_first_day_email[body]"]')[0]).val()
    before_user_first_day_email["button"] = $($('input[id^="course_before_user_first_day_email[button]"]')[0]).val()
    
    form_data =
      'course[custom_images]': course_images
      'course[custom_backgrounds]': course_backgrounds
      'course[custom_logos]': course_logos
      'course[custom_welcome_images]': course_welcome_images

      'course[custom_welcome_videos]': course_welcome_videos
      'course[custom_welcome_video_subtitles]': course_welcome_video_subtitles
      'course[custom_welcome_video_thumbnails]': course_welcome_video_thumbnails

      'course[welcome_file]': $(e.target).children().find('#course_welcome_file').val()
      'course[welcome_text]': $(e.target).children().find('#course_welcome_text').val()
      'course[welcome_text_multi]': welcome_text_multi
      'course[welcome_video_autoplay]': $("#course_welcome_video_autoplay_"+$('#course_name_language').val()).is(':checked')

      'course[alt_text_for_images]'         : alt_text_for_images
      'course[alt_text_for_backgrounds]'    : alt_text_for_backgrounds
      'course[alt_text_for_logos]'          : alt_text_for_logos
      'course[alt_text_for_welcome_images]' : alt_text_for_welcome_images

      'course[asset_id_for_images]'                   : asset_id_for_images
      'course[asset_id_for_backgrounds]'              : asset_id_for_backgrounds
      'course[asset_id_for_logos]'                    : asset_id_for_logos
      'course[asset_id_for_welcome_images]'           : asset_id_for_welcome_images
      'course[asset_id_for_welcome_video]'            : asset_id_for_welcome_video

      'course[name]': $(e.target).children().find('#course_name').val()
      'course[name_multi]': name_multi
      'course[hierarchy_unlocking]': $(e.target).children().find('#course_hierarchy_unlocking').val()
      'course[dependent_course]': $(e.target).children().find('#course_dependent_course').val()
      'course[required_percentage]': $(e.target).children().find('#course_required_percentage').val()
      'course[required_score]': $(e.target).children().find('#course_required_score').val()
      'course[language_id]': $(e.target).children().find('#course_language_id').val()
      'course[runtime]': $(e.target).children().find('#course_runtime').val()
      'course[dashboard]': dashboard
      'course[preboarding]': preboarding
      'course[leaderboard]': leaderboard
      'course[scoring_criteria]': scoring_criteria
      'course[leaderboard_user_name_criteria]': leaderboard_user_name_criteria
      'course[current_wave_id]': $('#course_current_wave_id').val()
      'course[decimal_notation]': $(e.target).children().find('#course_decimal_notation').val()
      'course[remind_completion_email]': remind_completion_email
      'course[reminder_email]': $(e.target).children().find('#course_reminder_email').val()
      'course[background_color]': $(e.target).children().find('#course_background_color').val()
      'course[languages_status]': course_languages_status
      'course[default_language_id]': $('[name^="course[language_default]"]:checked').val()
      'course[notifications_language_id]': $('[name^="course[notifications_language_id]"]').val()
      'course[dashboard_type]': dashboard_type

      'course[invite_email_type]': invite_email_type
      'course[invite_email]': invite_email
      'course[welcome_email_type]': welcome_email_type
      'course[welcome_email]': welcome_email

      'course[reset_password_email_type]': reset_password_email_type
      'course[reset_password_email]': reset_password_email
      'course[manager_following_email_type]': manager_following_email_type
      'course[manager_following_email]': manager_following_email
      'course[welcome_manager_email_type]': welcome_manager_email_type
      'course[welcome_manager_email]': welcome_manager_email
      'course[invite_manager_email_type]': invite_manager_email_type
      'course[invite_manager_email]': invite_manager_email
      'course[before_user_first_day_email_type]': before_user_first_day_email_type
      'course[before_user_first_day_email]': before_user_first_day_email
      'course[finished_course_email_type]': finished_course_email_type
      'course[finished_course_email]': finished_course_email
      'course[inactive_user_email_type]': inactive_user_email_type
      'course[inactive_user_email]': inactive_user_email
      'course[story_available_email_type]': story_available_email_type
      'course[story_available_email]': story_available_email
      'course[remind_course_completion_email_type]': remind_course_email_type
      'course[remind_course_completion_email]': remind_course_email
      'course[new_course_email_type]': new_course_email_type
      'course[new_course_email]': new_course_email

      'course[remind_completion][runtime_1]': $(e.target).find('#course_remind_completion_runtime_1').val()
      'course[remind_completion][progress_1]': $(e.target).find('#course_remind_completion_progress_1').val()
      'course[remind_completion][runtime_2]': $(e.target).find('#course_remind_completion_runtime_2').val()
      'course[remind_completion][progress_2]': $(e.target).find('#course_remind_completion_progress_2').val()
      'course[remind_completion][runtime_3]': $(e.target).find('#course_remind_completion_runtime_3').val()
      'course[remind_completion][progress_3]': $(e.target).find('#course_remind_completion_progress_3').val()

      'course[email_options][accept-invite]': $(e.target).find('#course_email_options_accept-invite').is(':checked')
      'course[email_options][course-completed]': $(e.target).find('#course_email_options_course-completed').is(':checked')
      'course[email_options][glossary-import]': $(e.target).find('#course_email_options_glossary-import').is(':checked')
      'course[email_options][user-import]': $(e.target).find('#course_email_options_user-import').is(':checked')
      'course[email_options][inactive-user]': $(e.target).find('#course_email_options_inactive-user').is(':checked')
      'course[email_options][available-story]': $(e.target).find('#course_email_options_available-story').is(':checked')
      'course[email_options][remind-complete-course]': $(e.target).find('#course_email_options_remind-complete-course').is(':checked')
      'course[email_options][new-course]': $(e.target).find('#course_email_options_new-course').is(':checked')
      'course[email_options][follower-progress]': $(e.target).find('#course_email_options_follower-progress').is(':checked')
      'course[email_options][pre-first-day-email]': $(e.target).find('#course_email_options_pre-first-day-email').is(':checked')
      'course[pre_first_day]': $(e.target).find('#course_pre_first_day').val()
      'course[waves]': course_waves

      'authenticity_token': $('input[name=authenticity_token]').val()
      '_method': 'patch'

    # The Notifications tab owns these fields once its flipper is on, and this page then stops
    # rendering their inputs - the empty reads above would blank them out on every settings save.
    if $(e.target).data('notifications-tab')
      notifications_tab_fields = [
        'course[runtime]'
        'course[pre_first_day]'
        'course[email_options]'
        'course[remind_completion_email]'
        'course[remind_completion]'
        'course[invite_email'
        'course[welcome_email'
        'course[reset_password_email'
        'course[before_user_first_day_email'
        'course[finished_course_email'
        'course[inactive_user_email'
        'course[story_available_email'
        'course[remind_course_completion_email'
        'course[new_course_email'
      ]
      for form_key of form_data
        delete form_data[form_key] if notifications_tab_fields.some((owned_field) -> form_key.indexOf(owned_field) == 0)

    if $("#push_notification_fields").find("[data-trigger]").length > 0
      $("#push_notification_fields").find("[name^='course[push_notifications_attributes]']").each ->
        form_data[$(this).attr('name')] = $(this).val()

    if $("#push_notification_chapter_fields").find("[data-trigger]").length > 0
      $("#push_notification_chapter_fields").find("[name^='course[push_notifications_chapter_attributes]']").each ->
        form_data[$(this).attr('name')] = $(this).val()

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      data: form_data
    ).done((data, textStatus, jqXHR) ->
      window.safeRedirect(data["redirect_to"])
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert(jqXHR.responseText)
      $("#update > input").val('Update')
      $("#update > input").attr('disabled', false)
      $('#loading-modal').closeModal()
      return
    )
    true

  $(document).on 'submit', '#new_course', (e) ->
    e.preventDefault()
    course_image          = ''
    asset_id              = $(e.target).children().find("#asset-id-course-image").val()
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()

    unless $(e.target).children().find(".course-image-uploaded").find("img").attr('src') == undefined
      if asset_library_allowed == 'false'
        course_image = $(e.target).children().find(".course-image-uploaded").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else
        course_image = ''

    if $(e.target).children().find('#course_dashboard_enable').is(':checked')
      dashboard = 1
    else
      dashboard = 0

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      data:
        'course[custom_image][base64]': course_image
        'course[custom_image][filetype]': fileObject.filetype_image
        'course[custom_image][filename]': fileObject.filename_image

        'course[image_alt_text]': $(e.target).children().find('#new_course_image_alt_text').val()
        'course[name]': $(e.target).children().find('#course_name').val()
        'course[language_id]': $(e.target).children().find('#course_language_id').val()
        'course[dashboard]': dashboard
        'course[application_id]': $(e.target).children().find('#course_application_id').val()
        'authenticity_token': $('input[name=authenticity_token]').val()
        'course[asset_id_for_images]': asset_id
    ).done((data, textStatus, jqXHR) ->
      window.safeRedirect(data["redirect_to"])
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert(jqXHR.responseText)
      return
    )
    true
    
  $(document).on('click', '.bp_language', (event) ->
    if document.getElementById($(event.target).attr("id")).style.border.indexOf("solid") >= 0
      $(event.target).css("border", "none")
      $(event.target).css("border-radius", "6px")
    else
      $(event.target).css("border", "lightgreen solid 2px")
      $(event.target).css("border-radius", "6px")
  )

  $(document).on('click', '.blueprint-wizard-popup', (event) ->
    if $(event.target).attr("class") == "bp_language"
      return
    if !($(this).hasClass('active'))
      $(this).siblings('a').removeClass('active')
      $(this).addClass('active')
  )

  $(document).on('click', '.blueprint-continue', (event) ->
    modal_to_close = $($(this).parents('.modal')[0]).attr("id")
    modal_to_open = $(this).parents(".blueprint-wizard-popup").attr("href")
    
    if $(this).parents(".blueprint-wizard-popup").hasClass('active')
      if $(this).parents(".blueprint-wizard-popup").hasClass('left-container')
        if(modal_to_open != '#')
          $('#' + modal_to_close).closeModal();
          $(this).parents(".blueprint-wizard-popup").removeClass('active')
          $(this).parents(".blueprint-wizard-popup").siblings('a').removeClass('active')
          setTimeout (->
            $(modal_to_open).openModal()
            return
          ), 250
      else
        selected_languages = []
        if document.getElementById('bp-nl').style.border.indexOf("solid") >= 0
          selected_languages.push("dutch")
        if document.getElementById('bp-gb').style.border.indexOf("solid") >= 0
          selected_languages.push("english")

        if selected_languages.length == 1
          window.location.href = '/blueprints/new?lang=' + selected_languages[0]
        else if selected_languages.length == 2
          window.location.href = '/blueprints/new?lang=all'
  )

  instantiateDarkroom = (cropbox, modal, croppie) ->
    element = $(cropbox)
    ratio = parseInt(element.attr('data-ratio-num'))/parseInt(element.attr('data-ratio-denom'))

    croppie_course = $(croppie).croppie({
      viewport: {
        width: parseInt(element.attr('data-width')),
        height: parseInt(element.attr('data-height'))
      }
    });

    if $(modal).find('.croppie-container').length > 1
      $(modal).find('.croppie-container:last').appendTo("#{modal} .main-image-container")
      $(modal).find('.croppie-container:first').remove()

  $('.save-cropped-image-btn').click ->
    if croppie_course
      src = croppie_course.get(0).src
      format = croppie_course.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      croppie_course.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.upload-preview img').attr('src', response)

  $('.course-language-selection-table .lso-radio .landuage-radio-button').click (event) ->
    move_assets = $('.course-language-selection-table').data('move-assets')

    if move_assets
      if confirm("Changing the default language will move all the assets from the original default language to the new default language. Existing assets in the new default language will not be replaced. Kindly proceed accordingly.")
      else
        event.preventDefault()

  remove_course_language_listener = (object) ->
    val = $(object).siblings('.language-name').html().trim()
    checked = $(object).siblings().find('input[type="radio"]').is(":checked")
    if checked == true
      alert ("Default language cannot be deleted.")
    else
      $(object).parent().remove()
      $('#add_course_languages').find('option[value="'+ val + '"]').css("display", "block")
      $('#add_course_languages').trigger("chosen:updated");
